import { NgModule } from "@angular/core";
import { DateTimeModule } from "./controls/date-time/date-time.module";
import { FileControlModule } from "./controls/file/file.module";
import { JobAssigneePickerModule } from "./job-assignee-picker/job-assignee-picker.module";
import { JobStatusItemModule } from "./job-status-item/job-status-item.module";
import { NavBarModule } from "./nav-bar/nav-bar.module";
import { NewJobPopoverModule } from "./new-job-popover/new-job-popover.module";
import { ProgressBarModule } from "./progress-bar/progress-bar.module";

@NgModule({
    imports: [
        DateTimeModule,
        JobAssigneePickerModule,
        JobStatusItemModule,
        NavBarModule,
        NewJobPopoverModule,
        ProgressBarModule
    ],
    exports: [
        DateTimeModule,
        JobAssigneePickerModule,
        JobStatusItemModule,
        NavBarModule,
        NewJobPopoverModule,
        ProgressBarModule
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/vas/modules-shared/shared.module.ts